import React, { useState } from "react";
import MainLayout from "../../Layout/mainLayout";
import "../DealsAndOffers/dealsAndOffers.css";
import ListApp from "../Manage Users/listUsers";
import ListKiosk from "../Manage Users/koiskUser";
import ListWeb from "../Manage Users/webUser";
import "./headerUser.css";
import { Skeleton } from "antd";

const STORAGE_KEY = "user_header_tab";

const HeaderUser = () => {
  const [selectedTable, setSelectedTable] = useState(
    localStorage.getItem(STORAGE_KEY) || "app_users"
  );
  const [loading, setLoading] = useState(false);


  const handleTableSelection = (table) => {
    if (table === selectedTable || loading) return;

    setLoading(true);
    setSelectedTable(table);
    localStorage.setItem(STORAGE_KEY, table);

    setTimeout(() => {
      setLoading(false);
    }, 400);
  };

  return (
    <MainLayout>
      <div className="dealsAndOffers-container">
        <div className={`bg-white border-10 padding-10 shadow-box ${loading ? "disabled-tabs" : ""}`}
          style={{ boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px", marginBottom: "20px" }}>
          <div className="hover_panel">
            <h4
              className={selectedTable === "app_users" ? "clicked" : ""}
              onClick={() => handleTableSelection("app_users")}
            >
              App User
            </h4>

            <h4
              className={selectedTable === "web_users" ? "clicked" : ""}
              onClick={() => handleTableSelection("web_users")}
            >
              Web User
            </h4>

            <h4
              className={selectedTable === "kiosk_users" ? "clicked" : ""}
              onClick={() => handleTableSelection("kiosk_users")}
            >
              Kiosk User
            </h4>
          </div>
        </div>

        {loading && (
          <div className="tab-loader">
            <Skeleton active paragraph={{ rows: 6 }} />
          </div>
        )}

        <div className={`fade-wrapper ${loading ? "hide" : ""}`}>
          <div style={{ display: selectedTable === "app_users" ? "block" : "none" }}>
            <ListApp />
          </div>

          <div style={{ display: selectedTable === "web_users" ? "block" : "none" }}>
            <ListWeb />
          </div>

          <div style={{ display: selectedTable === "kiosk_users" ? "block" : "none" }}>
            <ListKiosk />
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default HeaderUser;
